export const blogPosts = [
    "https://pastiestopoutine.com/redwood-np-oregon-coast/",
    "https://pastiestopoutine.com/columbia-river-gorge-and-mount-rainier-np/"
]

